import React, { memo } from "react"

import { Icon } from "@components/icon"
import { areEqual } from "@utils/general"

import ContactUs from "./contact-us/contact-us"
import ImportantLinks from "./important-links/important-links"
import IsoLinks from "./iso-accreditations/iso-accreditations"
import MailingListBanner from "./mailing-list-banner/mailing-list-banner"
import { RequestTradeAccount } from "./request-trade-account"
import TermsAndConditions from "./terms-and-conditions/terms-and-conditions"

import * as styles from "./footer.module.css"

const Footer = memo(({ location }) => {
  const isNotCheckoutPage = location?.pathname !== "/checkout"
  return (
    <div className={styles.container}>
      {/* <BottomBanner /> */}
      {isNotCheckoutPage ? (
        <div className={styles.content}>
          <div className={styles.logoContainer}>
            <Icon id="logo" width="200" height="74" />
            <RequestTradeAccount />
          </div>
          <div className={styles.links}>
            <IsoLinks />
            <ImportantLinks />
            <ContactUs />
            <MailingListBanner />
          </div>
        </div>
      ) : null}
      <TermsAndConditions />
    </div>
  )
}, areEqual)

Footer.displayName = "Footer"

export default Footer
